export const ALERTS_CHANGED_EVENT = "vpm:alerts-changed";

export function notifyAlertsChanged() {
  window.dispatchEvent(new CustomEvent(ALERTS_CHANGED_EVENT));
}
